import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { formatPrice } from '@spotahome/soyuz-currency';

import { Mediator } from '@spotahome/soyuz-mediator';

import LockIcon from '../icons/LockIcon';

import PiggyBankLabelCircledIcon from '../icons/PiggyBankLabelCircledIcon';

import { ListingCostItemShape } from '../../constants/shapes';

import { APPLY_ON_INCLUDED } from '../../constants/costs';

import { CHANNELS } from '../utils/constants';

import PaymentTimelineCard from './PaymentTimelineCard';
import PaymentTimeLineItem from './PaymentTimelineItem';

const noop = () => {};

const OnCheckIn = ({
  hasNoDeposit,
  isPricingCalculated,
  costs = {},
  currencyCode,
  isCollapsed = false,
  onSelectDates = noop
}) => {
  const totalValue = isPricingCalculated
    ? formatPrice(costs.total, currencyCode)
    : trans('book_now_modal.dates_input.label');

  const depositTag = hasNoDeposit
    ? {
        label: trans('search.filter.no-deposit.vp.title'),
        renderLeadingIcon: () => (
          <PiggyBankLabelCircledIcon width="15" height="24" />
        ),
        isSpaced: true,
        underlined: true,
        size: 'big'
      }
    : {
        label: trans('homecard.label.deposit.protected'),
        renderLeadingIcon: () => <LockIcon width="15" height="24" />,
        isSpaced: true,
        underlined: true,
        size: 'big',
        onClick: () => {
          Mediator.publish(CHANNELS.OPEN_DEPOSIT_PROTECTION_MODAL);
        }
      };

  if (isPricingCalculated && costs.total === 0) {
    return null;
  }

  return (
    <PaymentTimelineCard
      title={trans('payment.timeline.section.on_check_in.title')}
      value={totalValue}
      tags={[depositTag]}
      collapsible
      isCollapsed={isCollapsed}
      onValueClick={!isPricingCalculated ? onSelectDates : null}
    >
      {costs?.costs?.map(cost => (
        <PaymentTimeLineItem
          key={cost.type}
          title={cost.name ?? trans(`payment.timeline.cost.label.${cost.type}`)}
          value={cost.value}
          currencyCode={currencyCode}
          included={cost.applyOn === APPLY_ON_INCLUDED}
          tooltipText={cost.description || null}
        />
      ))}
    </PaymentTimelineCard>
  );
};

OnCheckIn.propTypes = {
  hasNoDeposit: PropTypes.bool.isRequired,
  isPricingCalculated: PropTypes.bool.isRequired,
  costs: PropTypes.shape(ListingCostItemShape),
  currencyCode: PropTypes.string.isRequired,
  isCollapsed: PropTypes.bool,
  onSelectDates: PropTypes.func
};

export default OnCheckIn;
